import React from 'react';
import { useSelector } from 'react-redux';
import * as ViewSelectors from 'selectors/ViewSelectors';
import { Theme } from '@mui/material';
import { WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import { OrderProduct, SetProduct } from 'common/types';
import { getProductNameWithVariant } from 'common/utils/productUtils';
import { getTranslation } from 'common/modules/translations';
import classNames from 'classnames';

export interface OwnProps {
	product: OrderProduct | SetProduct;
	setProduct?: boolean;
}

type Props = OwnProps & WithStyles<typeof styles>;

const ReceiptProductInfo = (props: Props) => {
	const { product, classes } = props;

	const productCode = (product.collectProductCode && product.productCode) || null;
	const din =
		(product.dinValues && (product.dinValues.customDin || product.dinValues.calculatedDin)) || null;
	const lang = useSelector(ViewSelectors.lang);
	const productCodeAndDinString = (
		<>
			{!!productCode ? 'ID: ' + productCode : ''}
			{!!productCode && !!din && ', '}
			{!!din ? 'DIN: ' + din : ''}
		</>
	);

	return (
		<>
			<span
				className={
					props.setProduct ? classNames(classes.receiptFont, classes.smFont) : classes.receiptFont
				}
			>
				{getProductNameWithVariant(
					getTranslation(product.name, lang),
					product.variant || null,
					lang,
					undefined,
				)}
			</span>
			{(!!productCode || !!din) && (
				<span
					className={classNames(classes.receiptFont, classes.smFont, classes.productAndDinString)}
				>
					{'('} {productCodeAndDinString} {')'}
				</span>
			)}
		</>
	);
};

const styles = (theme: Theme) =>
	createStyles({
		receiptFont: {
			fontFamily: ['arial'].join(','),
			color: 'black !important',
			fontWeight: 500,
			fontSize: 14,
			lineHeight: 1.2,
			'text-rendering': 'geometricPrecision',
			'-webkit-font-smoothing': 'subpixel-antialiased',
			marginRight: '2px',
		},
		smFont: {
			fontSize: 12,
		},
		productAndDinString: {
			whiteSpace: 'nowrap',
		},
	});

export default withStyles(styles)(ReceiptProductInfo);
